"use client";

import { c as _c } from "react/compiler-runtime";
import { usePathname } from "next/navigation";
import { useEffect, useState } from "react";
import { ErrorBoundary } from "react-error-boundary";
import FooterWrapper from "@/components/footer/FooterWrapper";
import MobileLayout from "@/components/layout/MobileLayout";
import SmallScreenLayout from "@/components/layout/SmallScreenLayout";
import WebLayout from "@/components/layout/WebLayout";
import LayoutErrorFallback from "@/components/providers/LayoutErrorFallback";
import { SIDEBAR_MOBILE_BREAKPOINT } from "@/constants/sidebar";
import { useGlobalRefresh } from "@/contexts/RefreshContext";
import useIsMobileScreen from "@/hooks/isMobileScreen";
import useDeviceInfo from "@/hooks/useDeviceInfo";
import { flushMobileLaunchTiming, markMobileLaunchStep } from "@/utils/monitoring/mobileLaunchTiming";
import type { ComponentType, ReactNode } from "react";
export default function LayoutWrapper(t0) {
  const $ = _c(18);
  const {
    children
  } = t0;
  const {
    isApp,
    hasTouchScreen
  } = useDeviceInfo();
  const {
    refreshKey
  } = useGlobalRefresh();
  const isSmallScreen = useIsMobileScreen();
  const [isTouchTabletViewport, setIsTouchTabletViewport] = useState(_temp);
  const pathname = usePathname();
  let t1;
  let t2;
  if ($[0] !== hasTouchScreen) {
    t1 = () => {
      if (!hasTouchScreen) {
        setIsTouchTabletViewport(false);
        return;
      }
      const browserWindow = globalThis.window;
      if (browserWindow === undefined) {
        setIsTouchTabletViewport(false);
        return;
      }
      const mediaQuery = browserWindow.matchMedia(`(max-width: ${SIDEBAR_MOBILE_BREAKPOINT - 0.02}px)`);
      setIsTouchTabletViewport(mediaQuery.matches);
      const listener = event => {
        setIsTouchTabletViewport(event.matches);
      };
      if (typeof mediaQuery.addEventListener === "function") {
        mediaQuery.addEventListener("change", listener);
        return () => {
          mediaQuery.removeEventListener?.("change", listener);
        };
      }
      const previousOnChange = mediaQuery.onchange;
      mediaQuery.onchange = listener;
      return () => {
        if (mediaQuery.onchange === listener) {
          mediaQuery.onchange = previousOnChange ?? null;
        }
      };
    };
    t2 = [hasTouchScreen];
    $[0] = hasTouchScreen;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  const isAccessOrRestricted = pathname?.startsWith("/access") || pathname?.startsWith("/restricted");
  let t3;
  if ($[3] !== pathname) {
    t3 = [pathname];
    $[3] = pathname;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  useEffect(_temp3, t3);
  let LayoutComponent = WebLayout;
  const isSmallLayout = hasTouchScreen && (isSmallScreen || isTouchTabletViewport);
  if (isApp) {
    LayoutComponent = MobileLayout;
  } else {
    if (isSmallLayout) {
      LayoutComponent = SmallScreenLayout;
    }
  }
  if (isAccessOrRestricted) {
    let t4;
    if ($[5] !== children) {
      t4 = <>{children}</>;
      $[5] = children;
      $[6] = t4;
    } else {
      t4 = $[6];
    }
    return t4;
  }
  let t4;
  if ($[7] !== pathname || $[8] !== refreshKey) {
    t4 = [pathname, refreshKey];
    $[7] = pathname;
    $[8] = refreshKey;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <FooterWrapper />;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== children || $[12] !== refreshKey || $[13] !== t4) {
    t6 = <ErrorBoundary key={refreshKey} FallbackComponent={LayoutErrorFallback} resetKeys={t4}>{children}{t5}</ErrorBoundary>;
    $[11] = children;
    $[12] = refreshKey;
    $[13] = t4;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== LayoutComponent || $[16] !== t6) {
    t7 = <LayoutComponent>{t6}</LayoutComponent>;
    $[15] = LayoutComponent;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
}
function _temp3() {
  const flushAfterPaint = _temp2;
  if (typeof globalThis.requestAnimationFrame === "function") {
    const frameId = globalThis.requestAnimationFrame(flushAfterPaint);
    return () => {
      globalThis.cancelAnimationFrame(frameId);
    };
  }
  const timeoutId = globalThis.setTimeout(flushAfterPaint, 0);
  return () => {
    globalThis.clearTimeout(timeoutId);
  };
}
function _temp2() {
  markMobileLaunchStep("first_useful_app_shell");
  flushMobileLaunchTiming("shell_paint");
}
function _temp() {
  if (globalThis.window === undefined) {
    return false;
  }
  return globalThis.window.innerWidth < SIDEBAR_MOBILE_BREAKPOINT;
}